<app-inm-carousel
  class="vr-carousel mx-auto {{ classWidth() }}"
  [class.vr-carousel--featured]="variant() === 'featured'"
  #myCarousel
  [inputs]="carouselTileConfig()"
  [dataSource]="vrMedia()"
  (activeIndexChange)="activeIndexChange.emit($event)"
>
  <div class="" *inmCarouselItem="let item; let i = index">
    <div class="content-card" [class.content-card--featured]="variant() === 'featured'">
      <app-vr-card [itemVr]="item" />
    </div>
  </div>

  <a
    inmCarouselPrev
    class="carousel-control-prev"
    role="button"
  >
    <div class="relleno">
      <span class="carousel-control-prev-icon c-c-p-i-w" aria-hidden="true"></span>
    </div>
  </a>

  <a
    inmCarouselNext
    class="carousel-control-next"
    role="button"
  >
    <div class="relleno">
      <span class="carousel-control-next-icon c-c-n-i-w" aria-hidden="true"></span>
    </div>
  </a>

  <ul class="myPoint" inmCarouselPoint>
    @for (item of myCarousel.pointNumbers(); track item) {
      <li
        [class.active]="$index == myCarousel.activePoint()"
        (click)="myCarousel.moveTo($index)"
      ></li>
    }
  </ul>
</app-inm-carousel>
